import React from 'react';
import entrada from '../assets/entrada.png';
import fachada from '../assets/entradaa.jpeg';
import recepcao1 from '../assets/recepcao_1.png';
import recepcao2 from '../assets/recepcao_2.png';

const GMAPS = 'https://www.google.com/maps/dir/?api=1&destination=-22.878592139894362,-43.46390571603235';

const photos = [
  {
    image: fachada,
    label: 'Fachada externa',
    title: 'Frente da clínica',
  },
  {
    image: entrada,
    label: 'Entrada da clínica',
    title: 'Nova fachada em Bangu',
  },
  {
    image: recepcao1,
    label: 'Recepção',
    title: 'Ambiente de chegada',
  },
  {
    image: recepcao2,
    label: 'Recepção',
    title: 'Espera confortável',
  },
];

const Location = () => (
  <>
    <div className="divider" id="localizacao">
      <span><span className="dot"></span> 07 / Nova sede</span>
      <span>Estamos aqui</span>
    </div>

    <section className="local">
      <div className="local-left">
        <div className="num eyebrow" style={{ marginBottom: 24 }}>Mudamos em 2026</div>
        <h2 className="display">Nova sede, <em>mais espaço</em> pra você.</h2>

        <div className="local-info">
          <div className="local-item">
            <span className="k">Endereço</span>
            <span className="v">
              Rua Silva Cardoso, 346
              <small>Bangu, Rio de Janeiro · CEP 21810-032</small>
            </span>
          </div>
          <div className="local-item">
            <span className="k">WhatsApp</span>
            <span className="v">
              (21) 97898-2711
              <small>Atendimento rápido, em horário comercial.</small>
            </span>
          </div>
          <div className="local-item">
            <span className="k">E-mail</span>
            <span className="v">banguodontoclinica@gmail.com</span>
          </div>
          <div className="local-item">
            <span className="k">Horário</span>
            <span className="v">
              Seg-Sex · 08:30 às 18:00
              <small>Sáb · 08:30 às 12:00 · Fechado aos domingos</small>
            </span>
          </div>
        </div>
      </div>

      <div className="map">
        <div className="map-bg"></div>
        <svg className="map-svg" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
          <polygon className="mall-shape" points="4,18 4,50 12,51 12,88 34,88 37,83 37,76 46,76 46,33 41,33 41,31 46,31 46,23 43,23 43,18" />
          <rect className="station-block" x="49" y="67" width="15" height="10" />
          <path className="real-road secondary" d="M54,-8 L54,18 L54,29" />
          <path className="real-road secondary" d="M54,61 L54,104" />
          <path className="real-road major" d="M84,-8 L84,13 L85,38 L85,76 L84,108" />
          <path className="real-road secondary" d="M53,18 L66,18 L86,17 L104,17" />
          <path className="real-road secondary" d="M53,80 L70,80 L86,79 L104,79" />
          <path className="real-road small" d="M2,92 L22,91 L39,88 L55,80" />
          <path className="real-road secondary" d="M67,-8 L67,28 L67,60 L66,97" />
          <path className="real-road small" d="M86,76 L95,76 L104,76" />
          <text className="road-name" x="86" y="29" transform="rotate(89 86 29)">RUA SILVA CARDOSO</text>
          <text className="road-name" x="56" y="47" transform="rotate(90 56 47)">RUA FONSECA</text>
          <text className="road-name" x="57" y="16">R. PROF. CLEMENTE FERREIRA</text>
          <text className="road-name" x="55" y="78">RUA FRANCISCO REAL</text>
          <text className="road-name" x="15" y="91" transform="rotate(-6 15 91)">RUA DA FEIRA</text>
          <text className="road-name" x="49" y="48" transform="rotate(90 69 48)">AV. CONEGO DE VASCONCELOS</text>
        </svg>
        <div className="map-label shopping-label">Bangu Shopping</div>
        <div className="map-label clinic-label">Bangu Odonto Clínica</div>
        <div className="map-ripple"></div>
        <div className="map-ripple"></div>
        <div className="map-ripple"></div>
        <div className="map-pin"><div className="map-pin-dot"></div></div>
        <a href={GMAPS} target="_blank" rel="noopener noreferrer" className="map-caption">
          <span>Google Maps</span>
          <strong>Solicitar rotas</strong>
        </a>
      </div>

      <div className="clinic-photo-grid local-gallery">
        {photos.map((photo) => (
          <figure className="clinic-photo" key={photo.title}>
            <img src={photo.image} alt={photo.title} />
            <figcaption>
              <span>{photo.label}</span>
              <strong>{photo.title}</strong>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  </>
);

export default Location;
